// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Nfhxt","add":"Button_add__2yknz","danger":"Button_danger__1cfH-","abort":"Button_abort__34tng","disabled":"Button_disabled__xk6Qi"};